import { Link } from 'react-router-dom';

export default function BlogSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="mb-10 md:mb-14">
        <span className="text-xs font-semibold text-primary-500 uppercase tracking-widest">
          Latest Resources
        </span>
        <h2 className="font-heading text-3xl md:text-4xl font-extrabold text-foreground-950 mt-3 leading-tight">
          Spreadsheet Guides &amp; Articles
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
        {/* Featured Guide */}
        <Link
          to="/kakobuy-spreadsheet-ultimate-guide-2026"
          className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
        >
          <div className="relative w-full h-44 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20desk%20with%20open%20laptop%20showing%20spreadsheet%20software%20and%20organized%20product%20data%2C%20a%20notepad%20with%20handwritten%20notes%20beside%20it%2C%20warm%20cream%20wall%20background%2C%20natural%20light%20from%20a%20window%2C%20clean%20editorial%20photography%20with%20soft%20shadows%2C%20professional%20but%20inviting%20workspace&width=800&height=500&seq=blog-guide-v2-01&orientation=landscape"
              alt="Kakobuy Spreadsheet Ultimate Guide 2026"
              title="Kakobuy Spreadsheet Ultimate Guide"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            <div className="absolute top-3 left-3">
              <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-semibold whitespace-nowrap">
                Featured
              </span>
            </div>
          </div>
          <div className="p-5">
            <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
              <i className="ri-calendar-line"></i>
              <span>July 2026</span>
              <span className="text-foreground-300">·</span>
              <i className="ri-time-line"></i>
              <span>15 min read</span>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2 group-hover:text-primary-500 transition-colors duration-200">
              The Ultimate Kakobuy Spreadsheet Guide: How to Shop Smarter in 2026
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              A complete step-by-step walkthrough of the Kakobuy Spreadsheet database — learn how to navigate categories, find the best products, and save hours of searching.
            </p>
            <div className="flex items-center gap-1 mt-4 text-primary-500 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <span>Read Full Article</span>
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </div>
        </Link>

        {/* Platform Comparison */}
        <Link
          to="/kakobuy-vs-cssbuy-vs-superbuy-comparison"
          className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
        >
          <div className="relative w-full h-44 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Four%20different%20styled%20laptops%20arranged%20side%20by%20side%20on%20a%20long%20wooden%20desk%2C%20each%20screen%20displaying%20a%20different%20colorful%20dashboard%2C%20warm%20cream%20background%20with%20natural%20light%2C%20comparison%20concept%2C%20clean%20editorial%20style%2C%20professional%20atmosphere&width=800&height=500&seq=blog-compare-v2-02&orientation=landscape"
              alt="Kakobuy vs CSSBuy vs Superbuy spreadsheet comparison"
              title="Kakobuy Spreadsheet Platform Comparison"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          </div>
          <div className="p-5">
            <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
              <i className="ri-calendar-line"></i>
              <span>July 2026</span>
              <span className="text-foreground-300">·</span>
              <i className="ri-time-line"></i>
              <span>18 min read</span>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2 group-hover:text-primary-500 transition-colors duration-200">
              Kakobuy vs CSSBuy vs Superbuy vs Oopbuy: Ultimate Comparison
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              An in-depth comparison of the four major product spreadsheet platforms across database size, update frequency, category coverage, and beginner-friendliness.
            </p>
            <div className="flex items-center gap-1 mt-4 text-primary-500 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <span>Read Full Article</span>
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </div>
        </Link>

        {/* Safety Guide */}
        <Link
          to="/kakobuy-spreadsheet-safety-buying-guide"
          className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-secondary-200/60 transition-all duration-300 cursor-pointer"
        >
          <div className="relative w-full h-44 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Desktop%20workspace%20with%20a%20shield%20icon%20on%20screen%20displaying%20security%20checklist%2C%20notebook%20with%20safety%20tips%20written%20beside%20keyboard%2C%20warm%20cream%20background%2C%20natural%20lighting%2C%20trust%20and%20protection%20concept%2C%20clean%20minimalist%20photography&width=800&height=500&seq=blog-safety-v2-03&orientation=landscape"
              alt="Kakobuy Spreadsheet safety and security guide"
              title="Kakobuy Spreadsheet Safety Guide"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          </div>
          <div className="p-5">
            <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
              <i className="ri-calendar-line"></i>
              <span>July 2026</span>
              <span className="text-foreground-300">·</span>
              <i className="ri-time-line"></i>
              <span>16 min read</span>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2 group-hover:text-primary-500 transition-colors duration-200">
              Safety Guide: How to Shop Securely and Avoid Scams
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              A comprehensive safety resource covering link verification, QC photo inspection, true cost calculation, seller research, and common red flags.
            </p>
            <div className="flex items-center gap-1 mt-4 text-primary-500 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <span>Read Full Article</span>
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </div>
        </Link>
      </div>

      {/* Row 2: More articles */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mt-6">
        {/* Beginner Guide */}
        <Link
          to="/kakobuy-spreadsheet-beginner-guide"
          className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
        >
          <div className="relative w-full h-44 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20inviting%20desk%20with%20a%20clean%20laptop%20showing%20a%20simple%20organized%20interface%2C%20coffee%20cup%20and%20plant%20nearby%2C%20soft%20natural%20lighting%2C%20calm%20beginner-friendly%20atmosphere%2C%20warm%20cream%20walls%2C%20fresh%20start%20concept%2C%20editorial%20photography&width=800&height=500&seq=blog-beginner-v2-04&orientation=landscape"
              alt="Kakobuy Spreadsheet beginner guide"
              title="Kakobuy Spreadsheet Beginner Guide"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          </div>
          <div className="p-5">
            <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
              <i className="ri-calendar-line"></i>
              <span>July 2026</span>
              <span className="text-foreground-300">·</span>
              <i className="ri-time-line"></i>
              <span>20 min read</span>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2 group-hover:text-primary-500 transition-colors duration-200">
              Beginner Guide: Everything You Need to Get Started
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              A complete walkthrough for first-time users. Learn what a product spreadsheet is, how to navigate categories, and make your first purchase safely.
            </p>
            <div className="flex items-center gap-1 mt-4 text-primary-500 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <span>Read Full Article</span>
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </div>
        </Link>

        {/* Shoes Guide */}
        <Link
          to="/kakobuy-shoes-spreadsheet-guide"
          className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
        >
          <div className="relative w-full h-44 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20display%20of%20various%20fashionable%20shoes%20on%20minimalist%20shelves%20against%20warm%20cream%20wall%2C%20sneakers%20and%20casual%20footwear%20in%20different%20colors%2C%20natural%20light%2C%20clean%20retail%20display%20style%2C%20editorial%20product%20photography%2C%20soft%20shadows&width=800&height=500&seq=blog-shoes-v2-05&orientation=landscape"
              alt="Kakobuy Spreadsheet shoes guide"
              title="Kakobuy Spreadsheet Shoes Guide"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          </div>
          <div className="p-5">
            <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
              <i className="ri-calendar-line"></i>
              <span>July 2026</span>
              <span className="text-foreground-300">·</span>
              <i className="ri-time-line"></i>
              <span>14 min read</span>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2 group-hover:text-primary-500 transition-colors duration-200">
              The Ultimate Shoes Spreadsheet Guide: Find Your Perfect Pair
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Dive deep into the most popular category. Learn how to find, evaluate, and score the best shoe deals across sneakers, formal footwear, and boots.
            </p>
            <div className="flex items-center gap-1 mt-4 text-primary-500 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <span>Read Full Article</span>
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </div>
        </Link>

        {/* Tips & Tricks */}
        <Link
          to="/kakobuy-spreadsheet-tips-and-tricks"
          className="group block bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-secondary-200/60 transition-all duration-300 cursor-pointer"
        >
          <div className="relative w-full h-44 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Productive%20workspace%20with%20multiple%20monitors%20displaying%20charts%20and%20data%2C%20colorful%20sticky%20notes%20on%20wall%2C%20organized%20desk%20with%20notebooks%2C%20warm%20cream%20background%2C%20natural%20light%2C%20efficiency%20and%20strategy%20concept%2C%20clean%20editorial%20photography&width=800&height=500&seq=blog-tips-v2-06&orientation=landscape"
              alt="Kakobuy Spreadsheet tips and tricks"
              title="Kakobuy Spreadsheet Tips and Tricks"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
          </div>
          <div className="p-5">
            <div className="flex items-center gap-2 text-xs text-foreground-500 mb-2">
              <i className="ri-calendar-line"></i>
              <span>July 2026</span>
              <span className="text-foreground-300">·</span>
              <i className="ri-time-line"></i>
              <span>16 min read</span>
            </div>
            <h3 className="font-heading font-semibold text-foreground-900 text-lg mb-2 group-hover:text-primary-500 transition-colors duration-200">
              25 Advanced Tips &amp; Tricks for Power Shoppers
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed">
              Move beyond the basics with proven strategies from experienced users. Master cross-category discovery, timing optimization, and multi-platform techniques.
            </p>
            <div className="flex items-center gap-1 mt-4 text-primary-500 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200">
              <span>Read Full Article</span>
              <i className="ri-arrow-right-line text-xs"></i>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
}